import { useEffect, useState } from "react";
import { Undo2 } from "lucide-react";
import type { Appointment } from "../../shared/domain";
import { api } from "../api";
import { useStore } from "../store";
export function AppointmentUndo({
  undo,
  onClose,
}: {
  undo: { a: Appointment; until: number };
  onClose: () => void;
}) {
  const { offline, refresh } = useStore();
  const [error, setError] = useState(""),
    [busy, setBusy] = useState(false);
  useEffect(() => {
    const timer = setTimeout(onClose, Math.max(0, undo.until - Date.now()));
    return () => clearTimeout(timer);
  }, [undo.until, onClose]);
  async function restore() {
    if (offline || busy) return;
    setBusy(true);
    try {
      await api("/appointments/" + undo.a.id + "/restore", "POST", {});
      await refresh();
      onClose();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="toast" role={error ? "alert" : "status"}>
      <span>{error || "Appointment deleted"}</span>
      {!error && (
        <button disabled={offline || busy} onClick={() => void restore()}>
          <Undo2 size={16} />
          Undo
        </button>
      )}
    </div>
  );
}
